import React, { useState } from 'react';
import styled from 'styled-components';
import RichText from 'utils/RichText';
import { sizes, width, colors, helpers, media } from 'styles/variables';
import Button from 'components/Button';
import Progress from 'components/Progress';
import UnitHandler from 'components/UnitHandler';
import { log } from 'utils/log';
import radio_0 from '../../static/radio_0.svg';
import radio_1 from '../../static/radio_1.svg';
import checkbox_0 from '../../static/checkbox_0.svg';
import checkbox_1 from '../../static/checkbox_1.svg';
import firebase from 'gatsby-plugin-firebase';
import cookie from 'react-cookies';

const Top = styled.div`
	text-align: center;
	h1 {
		${media.notsmall} {
			font-size: 3rem;
		}
		${media.small} {
			font-size: 1.75rem;
		}
	}
	p,
	li {
		font-size: 0.9rem;
		display: block;
		text-align: left;
		padding-bottom: ${sizes[2]};
	}
	li {
		background-image: url(${radio_1});
		background-repeat: no-repeat;
		background-position: left 0;
		background-size: 16px;
		padding-left: 24px;
	}
	em {
		white-space: nowrap;
		font-weight: 800;
		color: ${colors.brand.base};
	}
	img {
		width: 100%;
		max-width: 100%;
	}
`;
const BotNav = styled.small`
	display: block;
	width: 100%;
	text-align: center;
	cursor: pointer;
	padding: ${sizes[1]};
	text-decoration: underline;
	&:hover {
		text-decoration: none;
	}
`;
const Bot = styled.div`
	width: 100%;
	max-width: ${width.min}px;
	margin: 0 auto;
	a {
		display: block;
		&.--inactive {
			pointer-events: none;
			filter: grayscale(1) brightness(1.5);
		}
	}
`;

const Fields = styled.div`
	display: grid;
	grid-auto-flow: row;
	grid-gap: ${sizes[0]};
	max-width: ${width.min}px;
	width: 100%;
	margin: 0 auto;
`;

const Form = styled.form`
	&.--active {
		display: grid;
	}
	&.--inactive {
		display: none;
	}
	width: 100%;
	max-width: ${width.max}px;
	margin: 0 auto;
	padding: ${sizes[3]} ${sizes[2]} ${sizes[4]};
	grid-auto-flow: row;
	grid-gap: ${sizes[2]};
	label,
	.label {
		position: relative;
		cursor: pointer;
		background: ${colors.background[0]};
		&[type='multichoice'],
		&[type='singlechoice'] {
			display: grid;
			grid-template-columns: auto 1fr;
			align-items: center;
			grid-gap: ${sizes[1]};
			padding: ${sizes[2]};
			border-radius: ${sizes[0]};
			${helpers.shadow};
			border: 3px solid ${colors.background[0]};
			&.--active {
				border: 3px solid ${colors.teal.base};
			}
			div:first-of-type:before {
				content: '';
				display: block;
				width: 20px;
				height: 20px;
				background: center no-repeat;
				background-size: contain;
			}
		}
		&[type='multichoice'] {
			div:first-of-type:before {
				background-image: url(${checkbox_0});
			}
			&.--active div:first-of-type:before {
				background-image: url(${checkbox_1});
			}
		}
		&[type='singlechoice'] {
			div:first-of-type:before {
				background-image: url(${radio_0});
			}
			&.--active div:first-of-type:before {
				background-image: url(${radio_1});
			}
		}
		&[type='measurements_weight'],
		&[type='measurements_other'],
		&[type='name'],
		&[type='profile'] {
			input {
				padding: ${sizes[1]};
				width: 100%;
				text-align: center;
				border: 0;
				border-radius: ${sizes[0]};
				outline: none;
				border-bottom: 1px solid ${colors.background[2]};
			}
		}
		&[type='profile'],
		&[type='name'] {
			&[item-type='checkbox'] {
				display: grid;
				grid-template-columns: auto 1fr;
				align-items: center;
				grid-gap: ${sizes[1]};
				padding-top: ${sizes[1]};
				small {
					line-height: 1.5;
				}
				a {
					text-decoration: underline;
				}
				div:first-of-type:before {
					content: '';
					display: block;
					width: 20px;
					height: 20px;
					background: center no-repeat;
					background-size: contain;
					background-image: url(${checkbox_0});
				}
				&.--active {
					div:first-of-type:before {
						background-image: url(${checkbox_1});
					}
				}
			}
		}
		strong,
		small {
			display: block;
		}
	}
	input[type='checkbox'],
	input[type='radio'] {
		display: none;
	}
	input[type='number']::-webkit-inner-spin-button,
	input[type='number']::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	.imperialHeight {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: ${sizes[2]};
		> div {
			position: relative;
		}
	}
`;
const Unit = styled.div`
	font-weight: bold;
	position: absolute;
	right: 0;
	bottom: 0;
	height: 100%;
	display: grid;
	align-items: center;
	font-size: 0.8rem;
	display: -webkit-box;
	-webkit-box-orient: horizontal;
`;
const Error = styled.div`
	padding: ${sizes[2]};
	margin-bottom: ${sizes[2]};
	border-radius: ${sizes[0]};
	background: ${colors.red.base};
	color: ${colors.background[0]};
	display: block;
	width: 100%;
	font-size: 0.9rem;
	line-height: 150%;
`;

export default props => {
	const lang = props.pageContext.lang || '';
	const [error, setError] = useState(null);
	const [auth, setAuth] = useState(false);
	const [translations] = useState(require(`data/${lang}_translations`));

	let data = props.form.get.data[props.index];
	let json = data.form;

	const renderTop = () => {
		return (
			<Top>
				<Progress current={props.form.get.view + 1} total={props.form.get.data.length} />
				<small>{data.subtitle}</small>
				<RichText data={data.body} form={props.form} />
				{error && <Error>{error}</Error>}
				{(data.form.type === 'measurements_weight' || data.form.type == 'measurements_other') && (
					<UnitHandler {...props} form={props.form} />
				)}
			</Top>
		);
	};

	const renderBot = () => {
		let active = true;
		let valid = 0;
		if (data.form) {
			switch (data.form.type) {
				case 'multichoice':
				case 'singlechoice':
					data.form.data.map((item, index) => {
						if (item.value === true) {
							valid++;
						}
						return true;
					});
					if (valid === 0) {
						active = false;
					}
					break;
				case 'measurements_weight':
					clearTimeout(window.errorTimeout);
					window.errorTimeout = window.setTimeout(() => {
						setError(null);
					}, 300);
					let weight = {};
					data.form.data.map((item, index) => {
						weight[item.name] = item.value;
						if (item.value === false || item.value.length === 0) {
							active = false;
						}
						return true;
					});
					if (active) {
						console.log(weight);
						if (
							Number(weight.weight_current) < Number(weight.weight_desired) ||
							Number(weight.weight_current) < 40 ||
							Number(weight.weight_desired) < 40 ||
							Number(weight.weight_current) > 250 ||
							Number(weight.weight_desired) > 250
						) {
							active = false;
							clearTimeout(window.errorTimeout);
							window.errorTimeout = window.setTimeout(() => {
								setError('Please enter a valid weight');
							}, 300);
						}
					}
					break;
				case 'measurements_other':
					data.form.data.map((item, index) => {
						if (item.value === false || item.value.length === 0) {
							active = false;
						}
						return true;
					});
					break;
				case 'name':
					data.form.data.map((item, index) => {
						if (item.name === 'name') {
							if (!(item.value.length > 0)) {
								active = false;
							}
						}
					});
					break;
				case 'profile':
					data.form.data.map((item, index) => {
						if (item.name === 'legal' && item.value === false) {
							active = false;
						}
						if (item.name === 'email') {
							if (!validateEmail(item.value)) {
								active = false;
							}
						}
					});
					break;
				default:
					active = true;
					break;
			}
		}
		return (
			<Bot>
				<a
					href="/overview"
					onClick={e => handleNext(e, data.form.type)}
					className={active ? '--active' : '--inactive'}
				>
					<Button title={data.button} type={1} hue={'pink'} />
				</a>
				<BotNav onClick={() => props.form.back()}>{translations.back}</BotNav>
			</Bot>
		);
	};

	const validateEmail = email => {
		var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	};

	const handleNext = (e, type) => {
		e.preventDefault();
		switch (type) {
			case 'profile':
				let form = props.form.get;
				var db = firebase.firestore();
				const focusZones = [];
				[
					{ n: 'chest', v: '0' },
					{ n: 'belly', v: '1' },
					{ n: 'legs', v: '2' },
					{ n: 'arms', v: '3' },
					{ n: 'butt', v: '4' },
					{ n: 'full', v: '5' },
				].forEach((item, index) => {
					if (form.values[`areas_${item.n}`]) {
						focusZones.push(db.collection('focusZones').doc(item.v.toString()));
					}
				});
				let json = form.values;
				json.calc = form.calc;
				json.metric = form.metric;
				let profile = {
					webId: cookie.load('uid'),
					source: 'web',
					gender: 'female',
					name: form.values.name || '',
					age: form.values.age,
					activityLevel: db
						.collection('activityLevel')
						.doc(
							form.values.activity_high
								? '0'
								: form.values.activity_medium
								? '1'
								: form.values.activity_low
								? '2'
								: '',
						),
					startedWeight: Number(form.values.weight_current),
					currentWeight: Number(form.values.weight_current),
					targetWeight: Number(form.values.weight_desired),
					height: Number(form.values.height),
					dietType: db
						.collection('dietType')
						.doc(
							form.values.diet_any
								? '3'
								: form.values.diet_vegetarian
								? '1'
								: form.values.diet_keto || window.location.href.indexOf('/keto/') > -1
								? '2'
								: '',
						),
					mealFrequency: db
						.collection('mealFrequency')
						.doc(form.values.meals_2 ? '0' : form.values.meals_3 ? '1' : form.values.meals_4 ? '2' : ''),
					currentUnits: db.collection('unitsType').doc('0'),
					email: form.values.email,
					sendEmails: form.values.newsletter,
					focusZones: focusZones,
					job: db
						.collection('job')
						.doc(
							form.values.work_inactive
								? '0'
								: form.values.work_active
								? '1'
								: form.values.work_mix
								? '2'
								: '',
						),
					purchased: false,
					json: json,
					sessions: [JSON.parse(sessionStorage.getItem('sessions'))],
				};
				if (auth === form.values.email) {
					setError(null);
					props.form.next(e);
				} else {
					localStorage.setItem('id', btoa(form.values.email));
					firebase
						.auth()
						.createUserWithEmailAndPassword(form.values.email, '_reshape_no_password')
						.then(async () => {
							setError(null);
							firebase.auth().onAuthStateChanged(async user => {
								// log('Order', 'Store', 'user_authentication');
								if (user) {
									db.collection('users')
										.doc(user.uid)
										.set(profile)
										.then(function() {
											// log('Order', 'Store', 'user_profile');
											console.log('Document written successfully');
											firebase.analytics().setUserProperties({ source: 'web' });
											setAuth(form.values.email);
											props.form.next(e);
										})
										.catch(function(error) {
											console.error('Error writing document: ', error);
										});
								}
							});
						})
						.catch(async error => {
							// const errorMessage = error.message.replace('The email address', form.values.email);
							const errorMessage = `${form.values.email} is already in use by another Reshape community member`;
							firebase
								.auth()
								.signInWithEmailAndPassword(form.values.email, '_reshape_no_password')
								.then(function(user) {
									db.collection('users')
										.doc(user.user.uid)
										.update(profile)
										.then(function() {
											console.log('Document updated successfully');
											firebase.analytics().setUserProperties({ source: 'web' });
											setAuth(form.values.email);
											props.form.next(e);
										})
										.catch(function(error) {
											console.log(error);
										});
								})
								.catch(function() {
									setError(errorMessage);
								});
						});
				}
				break;
			default:
				props.form.next(e);
				break;
		}
	};

	const renderFields = () => {
		switch (json.type) {
			case 'multichoice':
			case 'singlechoice':
				return (
					<>
						{json.data.map((item, index) => (
							<label type={json.type} key={index} className={item.value ? '--active' : '--inactive'}>
								<input
									name={json.name}
									value={item.name}
									type={json.type === 'multichoice' ? 'checkbox' : 'radio'}
									defaultChecked={item.value === true}
									onChange={e => props.form.set(props.index, index, !item.value)}
								/>
								<div />
								<div>
									{item.title && <strong>{item.title}</strong>}
									{item.subtitle && <small>{item.subtitle}</small>}
								</div>
							</label>
						))}
					</>
				);
			case 'measurements_weight':
				if (props.form.get.metric) {
					return (
						<>
							{json.data.map((item, index) => (
								<label type={json.type} key={index}>
									<Unit>{item.units[0]}</Unit>
									<input
										type="number"
										key={index}
										pattern="[0-9]*"
										name={item.name}
										placeholder={item.title}
										value={item.value && Math.round(item.value * 10) / 10}
										onChange={e => props.form.set(props.index, index, e.target.value)}
									/>
								</label>
							))}
						</>
					);
				} else {
					return (
						<>
							{json.data.map((item, index) => (
								<label type={json.type} key={index}>
									<Unit>{item.units[1]}</Unit>
									<input
										type="number"
										key={index}
										pattern="[0-9]*"
										name={item.name}
										placeholder={item.title}
										value={item.value && Math.round((item.value / 0.45359237) * 10) / 10}
										onChange={e => props.form.set(props.index, index, e.target.value * 0.45359237)}
									/>
								</label>
							))}
						</>
					);
				}

			case 'measurements_other':
				return (
					<>
						{json.data.map((item, index) => {
							if (item.name === 'height') {
								if (props.form.get.metric) {
									return (
										<label type={json.type} key={index}>
											<Unit>{item.units[0]}</Unit>
											<input
												type="number"
												key={index}
												pattern="[0-9]*"
												name={item.name}
												placeholder={item.title}
												defaultValue={item.value && Math.floor(item.value)}
												onChange={e => props.form.set(props.index, index, e.target.value)}
											/>
										</label>
									);
								} else {
									const totalInches = item.value * 0.393701;
									const feet = Math.floor(totalInches / 12);
									const inches = Math.floor(totalInches - feet * 12);
									const handleImperialHeight = e => {
										const feet = Number(
											e.target.closest('.label').querySelector('input[name=height_feet]').value,
										);
										const inches = Number(
											e.target.closest('.label').querySelector('input[name=height_inches]').value,
										);
										const cm = (feet * 12 + inches) / 0.393701;
										props.form.set(props.index, index, cm);
									};
									return (
										<div className="label" type={json.type} key={index}>
											<div className="imperialHeight">
												<label>
													<div>
														<Unit>{item.units[1].split(',')[0]}</Unit>
														<input
															type="number"
															key={`${index}_feet`}
															pattern="[0-9]*"
															name="height_feet"
															placeholder={item.title}
															value={item.value && feet}
															onChange={e => handleImperialHeight(e)}
															onClick={e => {
																e.target.value = '';
															}}
														/>
													</div>
												</label>
												<label>
													<div>
														<Unit>{item.units[1].split(',')[1]}</Unit>
														<input
															type="number"
															key={`${index}_inches`}
															pattern="[0-9]*"
															name="height_inches"
															placeholder={item.title}
															value={item.value && inches}
															onChange={e => handleImperialHeight(e)}
															onClick={e => {
																e.target.value = '';
															}}
														/>
													</div>
												</label>
											</div>
										</div>
									);
								}
							} else {
								return (
									<label type={json.type} key={index}>
										<Unit>{item.units[0]}</Unit>
										<input
											type="number"
											key={index}
											pattern="[0-9]*"
											name={item.name}
											placeholder={item.title}
											defaultValue={item.value}
											onChange={e => props.form.set(props.index, index, e.target.value)}
										/>
									</label>
								);
							}
						})}
					</>
				);
			case 'name':
				return (
					<>
						{json.data.map((item, index) => {
							return (
								<label type={json.type} key={index}>
									<input
										type={item.type}
										key={index}
										name={item.name}
										placeholder={item.title}
										defaultValue={item.value}
										onChange={e => props.form.set(props.index, index, e.target.value)}
									/>
								</label>
							);
						})}
					</>
				);
			case 'profile':
				return (
					<>
						{json.data.map((item, index) => {
							switch (item.type) {
								case 'text':
								case 'number':
									return <></>;
								case 'email':
									return (
										<label type={json.type} item-type={item.type} key={index}>
											<input
												type={item.type}
												placeholder={item.title}
												name={item.name}
												defaultValue={item.value}
												onChange={e => props.form.set(props.index, index, e.target.value)}
												onKeyPress={event => {
													if (event.key === 'Enter') {
														event.preventDefault();
													}
												}}
											/>
										</label>
									);
								case 'checkbox':
									return (
										<label
											type={json.type}
											item-type={item.type}
											key={index}
											className={item.value ? '--active' : '--inactive'}
										>
											<input
												type={item.type}
												name={item.name}
												defaultChecked={item.value}
												onChange={e => {
													log('Onboarding', 'Toggle', `${item.name}_${!item.value}`);
													props.form.set(props.index, index, !item.value);
												}}
											/>
											<div />
											<small dangerouslySetInnerHTML={{ __html: item.title }}></small>
										</label>
									);
								default:
									return <></>;
							}
						})}
					</>
				);
			default:
				return <></>;
		}
	};

	if (props.index === props.form.get.view) {
		return (
			<Form key={props.index} className={props.index === props.form.get.view ? '--active' : '--inactive'}>
				{renderTop()}
				<Fields>{renderFields()}</Fields>
				{renderBot()}
			</Form>
		);
	} else {
		return <></>;
	}
};
